













































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import DateTimeUtils from '@/lib/dateTimeUtils';
import UpdateWorkerGeneralDetailsRequest from '@/models/Workers/UpdateWorkerGeneralDetailsRequest';
import UpdateWorkerAvailabilityRestrictionRequest from '@/models/Workers/UpdateWorkerTempAvailabilityRestrictionRequest';

@Component({
    name: 'WorkerGeneralDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public datePicker = false;
  public worker = new WorkerDto();
  public dateOfBirth = '';
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
      if (this.worker.dateOfBirth !== null) {
        this.dateOfBirth = new Date(this.worker.dateOfBirth).toISOString().substr(0, 10)
      } 
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  get availabilityRestrictions() {
    return ListUtils.availabilityRestrictions();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new UpdateWorkerAvailabilityRestrictionRequest();
    request.updatedAt = this.worker.updatedAt;
    request.availabilityRestriction = this.worker.availabilityRestriction;

    await WorkerDetailsModule.editAvailabilityRestriction(request)
    this.dialog = false;
  }


  
}
